import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './styles.scss';

/**
 * A card containing a Brand’s logo, optionally linking to a URL.
 */

export default function BrandLogoCard({
  brandName,
  logoUrl,
  backgroundColor,
  href,
  onClick,
  isBlock,
}) {
  const content = href ? (
    <a href={href} onClick={onClick} className={styles.link}>
      {brandName}
    </a>
  ) : (
    brandName
  );

  return (
    <div
      className={classnames(styles.card, { [styles.withLink]: !!href, [styles.isBlock]: isBlock })}
      style={{ backgroundImage: `url(${logoUrl})`, backgroundColor }}
    >
      {content}
    </div>
  );
}

BrandLogoCard.propTypes = {
  /**
   * The display name of the brand — present for SEO purposes.
   */
  brandName: PropTypes.string.isRequired,

  /**
   * The path to the logo image file.
   */
  logoUrl: PropTypes.string.isRequired,

  /**
   * An optional background colour, as a hex value
   */
  backgroundColor: PropTypes.string,

  /**
   * Optional href to link the card to
   */
  href: PropTypes.string,

  /**
   * Optional onClick event handler for the card
   */
  onClick: PropTypes.func,

  /**
   * Optional display prop — should the component be rendered as a block-level
   * cell with 100% parent width?
   */
  isBlock: PropTypes.bool,
};

BrandLogoCard.defaultProps = {
  backgroundColor: undefined,
  href: undefined,
  onClick: undefined,
  isBlock: false,
};
